import React from 'react';
import AdminLead2Detail from './AdminLead2Detail';
import AdminLayout from './AdminLayout';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { Leads2PortalProvider } from '../../contexts/Leads2PortalContext';

const AdminLead2DetailPage = () => {
  const { adminToken, adminUser } = useAdminAuth();
  const value = {
    token: adminToken,
    role: 'admin',
    basePath: '/admin/leads2',
    currentUserId: adminUser?.id || null,
    currentUserName: adminUser ? `${adminUser.firstName || ''} ${adminUser.lastName || ''}`.trim() : null,
    Layout: AdminLayout,
  };
  return (
    <Leads2PortalProvider value={value}>
      <AdminLead2Detail />
    </Leads2PortalProvider>
  );
};

export default AdminLead2DetailPage;
